import { HomePageEffects } from './ui/home page/effects/home-page.effects';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { filter, first, map, switchMap, tap } from 'rxjs/operators';
import { RootState } from './root.reducer';
import { UserEffects } from './user/effects/user.effects';
import * as RootActions from "./root.actions";
import * as UserActions from "./user/actions/user.actions";
import { OrderUiEffects } from './ui/order/effects/order-ui.effects';
import { WindowDetailEffects } from './ui/window/effects/window-detail.effects'
import { selectOmisUser } from './user/selectors/user.selectors';
import { getCookieAgreeementAgreed, localStorageIsValid, notEmptyNullUndefined } from '../helpers/utils';
import { CookieService } from 'ngx-cookie-service';
import { EUserRole, User } from '../models/data/user.model';
import {  Customer } from '../models/data/customer.model';
import * as HomePageActions from './ui/home page/actions/home-page.actions'
@Injectable()
export class RootEffects {

  constructor(
    private actions$: Actions,
    private store: Store<RootState>,
    private cookies: CookieService,

  ) { }

  debug$ = createEffect(() => this.actions$.pipe(
    // tap(({ type }) => console.debug(`[NGRX] ${type} @ ${new Date(Date.now()).toLocaleString()}`))
  ), { dispatch: false })

  /**
   * do the api whitch dont need token,
   * should do when init the web
   */


  /**
   * do the api when log in
   * need token (important)
   */
  fetchEntities$ = createEffect(() => this.actions$.pipe(
    ofType(RootActions.fetchEntities),
    tap(({ omisUser }) => {
      // this.store.dispatch(CustomerAddressActions.fetchCustomerAddressByUserId({ salesiqUserId: { salesiqUserId: user.salesIqUserId } }))
      // this.store.dispatch(CustomerActions.fetchAllCustomersByUserId({ salesiqUserId: { salesiqUserId: user.salesIqUserId } }))
      // this.store.dispatch(OrderActions.fetchShortOrdersByUserIdAndTimePeriod({}))
      //billing
      // this.store.dispatch(CustomertransActions.fetchCustomerTransByUserId({ salesiqUserId: { salesiqUserId: user.salesIqUserId } }))
      // this.store.dispatch(RootActions.loadCookiesAndFetchPriceList())

      //discoutn relate
      // this.store.dispatch(DiscountActions.fetchBonusItem())
      // this.store.dispatch(DiscountActions.fetchBonusPromotionPrice())
      // this.store.dispatch(DiscountActions.fetchThreshold())
      // this.store.dispatch(DiscountActions.fetchBonusPromotionHeader())
      // this.store.dispatch(DiscountActions.fetchPromotionProduct())

      this.store.dispatch(HomePageActions.fetchUiDepartment())
      this.store.dispatch(HomePageActions.fetchStaticData())
      this.store.dispatch(UserActions.fetchUserAuth())
    }),
  ), { dispatch: false })

  ///////////// non ngrx //////////////

  /**
 * will check cookie contain the selectedCustomer or not
 * if exist, return in a array and return
 * else crate a empty selected bp uuid and return it
 * update 13/09/2022 in OMIS version, will use local storage instead of cookies
 * @returns bp uuid items in array[]
 */
  private LoadSelectedBpCookiesAndFetchPriceList = (user: User, customer: Customer[]): string => {
    if(localStorageIsValid(`omis_selectedBp_${user.username}`)){
      return JSON.parse(localStorage.getItem(`omis_selectedBp_${user.username}`))
    } else {
      if (user.role === EUserRole.CUSTOMER) {//dont check agreement, not sure use in OMIS or not
        // this.cookies.set(`omis_selectedBp_${user.username}`, JSON.stringify(customer[0].customerUuid), null, '/')
        localStorage.setItem(`omis_selectedBp_${user.username}`,JSON.stringify(customer[0].customerUuid))
        return customer[0].customerUuid
      } else {
        // this.cookies.set(`omis_selectedBp_${user.username}`, JSON.stringify(null), null, '/')
        localStorage.setItem(`omis_selectedBp_${user.username}`,JSON.stringify(null))
        return null
      }
    }
  }

}

export const rootEffects = [
  RootEffects,
  UserEffects,
  OrderUiEffects,
  WindowDetailEffects,
  HomePageEffects,
]
